import { Component, OnInit } from '@angular/core'
import {MatDialogRef} from '@angular/material/dialog'

@Component({
  templateUrl: './comentario.component.html',
  styleUrls: ['./comentario.component.scss']
})
export class DeteccionFraudesComentarioComponent implements OnInit {
  comment: string =''
  constructor(
    public dialogRef: MatDialogRef<DeteccionFraudesComentarioComponent>,
  ) { }
  ngOnInit () {}
  sendComment(){
    this.dialogRef.close(this.comment)
  }
}
